import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../components/atoms/icon/icon';


export default {
  attributeName: 'liveAppManager',
  isDragable: false,
  canOpen: true,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  emptyMessage: "You don't have any manager created yet.",
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      type: FormInputTypes.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Content id.',
    },
    {
      attributeName: 'name',
      label: 'Manager Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'objective',
      label: 'Objective',
      type: FormInputTypes.ARRAY,
      fields: ['name'],
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'managerLink',
      label: 'Run Manager',
      type: FormInputTypes.LINK,
      icon: IconType.VIDEO,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Live manager for this event.',
    },   
     
  ],
};
